import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/template/UsecaseNew.tsx");
